/* Danh mục loại chứng từ, mẫu chữ ký, hình thức thanh toán. Port từ app cũ. */

export type VoucherType =
  | 'invoice' | 'receipt' | 'pt' | 'pc' | 'debit' | 'payreq' | 'credit' | 'cktm'
  | 'dep_in' | 'dep_refund' | 'dep_penalty';

export type VoucherKind = 'items' | 'cash' | 'dep';
export type SigSet = 'in' | 'out' | 'doc' | 'rc' | 'pen';
export type Scope = 'docs' | 'cash';

/** [tiếng Việt, tiếng Anh, khóa người ký] */
export type SigSlot = [string, string, 'director' | 'chiefAcc' | 'party' | 'preparer' | 'cashier'];

export const SIG: Record<SigSet, SigSlot[]> = {
  in: [['Tổng giám đốc', 'CEO', 'director'], ['Kế toán trưởng', 'Chief Accountant', 'chiefAcc'], ['Người nộp tiền', 'Payer', 'party'], ['Người lập phiếu', 'Prepared by', 'preparer'], ['Thủ quỹ', 'Cashier', 'cashier']],
  out: [['Tổng giám đốc', 'CEO', 'director'], ['Kế toán trưởng', 'Chief Accountant', 'chiefAcc'], ['Thủ quỹ', 'Cashier', 'cashier'], ['Người lập phiếu', 'Prepared by', 'preparer'], ['Người nhận tiền', 'Recipient', 'party']],
  doc: [['Người lập', 'Prepared by', 'preparer'], ['Kế toán trưởng', 'Chief Accountant', 'chiefAcc'], ['Tổng giám đốc', 'CEO', 'director']],
  rc: [['Người lập', 'Prepared by', 'preparer'], ['Người nộp', 'Payer', 'party'], ['Kế toán trưởng', 'Chief Accountant', 'chiefAcc'], ['Thu ngân', 'Cashier', 'cashier'], ['Tổng giám đốc', 'CEO', 'director']],
  pen: [['Khách hàng xác nhận', 'Customer acknowledgement', 'party'], ['Người lập', 'Prepared by', 'preparer'], ['Kế toán trưởng', 'Chief Accountant', 'chiefAcc'], ['Tổng giám đốc', 'CEO', 'director']],
};

export interface VoucherTypeDef {
  vi: string;
  en: string;
  short: string;
  pre: string;
  kind: VoucherKind;
  party: [string, string];
  sig: SigSet;
  dr: string;
  cr: string;
  scope?: Scope;
  form?: string;
  acc?: boolean;
  template?: string;
}

export const VOUCHER_TYPES: Record<VoucherType, VoucherTypeDef> = {
  invoice: { vi: 'HÓA ĐƠN', en: 'Invoice', short: 'Invoice', pre: 'INV', kind: 'items', party: ['Khách hàng', 'Bill to'], sig: 'doc', dr: '131', cr: '5113', template: 'flyone-inv-2026' },
  receipt: { vi: 'BIÊN NHẬN', en: 'Receipt', short: 'Receipt', pre: 'RC', kind: 'cash', party: ['Nhận của', 'Received from'], sig: 'rc', dr: '1121', cr: '131' },
  pt: { vi: 'PHIẾU THU TIỀN MẶT', en: 'Cash receipt voucher', short: 'Phiếu thu tiền mặt', scope: 'cash', pre: 'PT', kind: 'cash', party: ['Người nộp tiền', 'Payer'], sig: 'in', dr: '1111', cr: '131', form: '01-TT', acc: true },
  pc: { vi: 'PHIẾU CHI TIỀN MẶT', en: 'Cash payment voucher', short: 'Phiếu chi tiền mặt', scope: 'cash', pre: 'PC', kind: 'cash', party: ['Người nhận tiền', 'Payee'], sig: 'out', dr: '331', cr: '1111', form: '02-TT', acc: true },
  debit: { vi: 'GIẤY BÁO NỢ', en: 'Debit note', short: 'Debit Note', pre: 'DN', kind: 'items', party: ['Gửi đến', 'To'], sig: 'doc', dr: '131', cr: '5113' },
  payreq: { vi: 'ĐỀ NGHỊ THANH TOÁN', en: 'Payment request', short: 'Đề nghị thanh toán', pre: 'DNTT', kind: 'items', party: ['Kính gửi', 'To'], sig: 'doc', dr: '131', cr: '5113' },
  credit: { vi: 'GIẤY BÁO CÓ', en: 'Credit note', short: 'Credit Note', pre: 'CN', kind: 'items', party: ['Gửi đến', 'To'], sig: 'doc', dr: '5213', cr: '131' },
  cktm: { vi: 'THÔNG BÁO CHIẾT KHẤU THƯƠNG MẠI', en: 'Commercial discount notice', short: 'Thông báo CKTM', pre: 'CKTM', kind: 'items', party: ['Gửi đến', 'To'], sig: 'doc', dr: '5211', cr: '131' },
  dep_in: { vi: 'PHIẾU THU CỌC', en: 'Deposit receipt', short: 'Phiếu thu cọc', pre: 'TC', kind: 'dep', party: ['Người nộp tiền', 'Payer'], sig: 'in', dr: '1121', cr: '344', form: '01-TT', acc: true },
  dep_refund: { vi: 'PHIẾU HOÀN CỌC', en: 'Deposit refund voucher', short: 'Hoàn cọc', pre: 'HC', kind: 'dep', party: ['Người nhận tiền', 'Payee'], sig: 'out', dr: '344', cr: '1121', form: '02-TT', acc: true },
  dep_penalty: { vi: 'PHIẾU PHẠT CỌC', en: 'Deposit forfeiture notice', short: 'Phạt cọc', pre: 'PPC', kind: 'dep', party: ['Khách hàng', 'Customer'], sig: 'pen', dr: '344', cr: '711', acc: true },
};

export const VOUCHER_TYPE_KEYS = Object.keys(VOUCHER_TYPES) as VoucherType[];

export const METHOD: Record<string, [string, string]> = {
  bank: ['Chuyển khoản', 'Bank transfer'],
  cash: ['Tiền mặt', 'Cash'],
  card: ['Thẻ', 'Card'],
  offset: ['Bù trừ công nợ', 'Offset against balance'],
};

export const VAT_OPTS: [string, string][] = [['0', '0%'], ['5', '5%'], ['8', '8%'], ['10', '10%'], ['kct', 'KCT'], ['na', '—']];

/** Kiểu dòng dữ liệu đoàn <-> loại phiếu cọc. */
export const KIND2TYPE: Record<string, VoucherType> = { 'Cọc': 'dep_in', 'Hoàn cọc': 'dep_refund', 'Phạt cọc': 'dep_penalty' };
export const TYPE2KIND: Partial<Record<VoucherType, string>> = { dep_in: 'Cọc', dep_refund: 'Hoàn cọc', dep_penalty: 'Phạt cọc' };

export const isDep = (t: string): boolean => t.startsWith('dep_');
export const scopeOf = (t: VoucherType): Scope => VOUCHER_TYPES[t]?.scope || 'docs';

/** Các loại phiếu làm tăng/giảm quỹ tiền mặt. */
export const CASH_IN: VoucherType[] = ['pt', 'dep_in'];
export const CASH_OUT: VoucherType[] = ['pc', 'dep_refund'];
